// extracted by mini-css-extract-plugin
module.exports = {"cls1":"TaskWorklistsPage-CssProp1_th-module--cls1--1ITd_","cls2":"TaskWorklistsPage-CssProp1_th-module--cls2--10Y7c TaskWorklistsPage-CssProp1_th-module--cls1--1ITd_"};